import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-drill-plan-callback',
  template: `
    <div class="flex items-center justify-center h-full">
      <p>Connecting to DrillPlan...</p>
    </div>
  `,
  standalone: false
})
export class DrillPlanCallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    console.log('DrillPlan callback received:', {
      code: code ? `${code.substring(0, 20)}...` : 'NO CODE',
      origin: window.location.origin,
      openerExists: !!window.opener
    });

    if (code && window.opener) {
      console.log('Posting auth code back to opener');
      window.opener.postMessage({ type: 'drillplan-auth', code }, window.location.origin);
      window.close();
    } else {
      console.error('Cannot complete auth flow:', {
        hasCode: !!code,
        hasOpener: !!window.opener
      });
    }
  }
}

